"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFormQuestionCreateCommand = instanceOfFormQuestionCreateCommand;
exports.FormQuestionCreateCommandFromJSON = FormQuestionCreateCommandFromJSON;
exports.FormQuestionCreateCommandFromJSONTyped = FormQuestionCreateCommandFromJSONTyped;
exports.FormQuestionCreateCommandToJSON = FormQuestionCreateCommandToJSON;
exports.FormQuestionCreateCommandToJSONTyped = FormQuestionCreateCommandToJSONTyped;
var FormQuestionKind_1 = require("./FormQuestionKind");
var FormOptionCreateCommand_1 = require("./FormOptionCreateCommand");
/**
 * Check if a given object implements the FormQuestionCreateCommand interface.
 */
function instanceOfFormQuestionCreateCommand(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
function FormQuestionCreateCommandFromJSON(json) {
    return FormQuestionCreateCommandFromJSONTyped(json, false);
}
function FormQuestionCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'disambiguatingDescription': json['disambiguatingDescription'] == null ? undefined : json['disambiguatingDescription'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'description': json['description'] == null ? undefined : json['description'],
        'kind': (0, FormQuestionKind_1.FormQuestionKindFromJSON)(json['kind']),
        'required': json['required'] == null ? undefined : json['required'],
        'shuffle': json['shuffle'] == null ? undefined : json['shuffle'],
        'navigable': json['navigable'] == null ? undefined : json['navigable'],
        'encrypted': json['encrypted'] == null ? undefined : json['encrypted'],
        'validation': json['validation'] == null ? undefined : json['validation'],
        'previewUrl': json['previewUrl'] == null ? undefined : json['previewUrl'],
        'answersLockable': json['answersLockable'] == null ? undefined : json['answersLockable'],
        'options': json['options'] == null ? undefined : (json['options'].map(FormOptionCreateCommand_1.FormOptionCreateCommandFromJSON)),
        'includeInEmail': json['includeInEmail'] == null ? undefined : json['includeInEmail'],
    };
}
function FormQuestionCreateCommandToJSON(json) {
    return FormQuestionCreateCommandToJSONTyped(json, false);
}
function FormQuestionCreateCommandToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'disambiguatingDescription': value['disambiguatingDescription'],
        'ordinal': value['ordinal'],
        'description': value['description'],
        'kind': (0, FormQuestionKind_1.FormQuestionKindToJSON)(value['kind']),
        'required': value['required'],
        'shuffle': value['shuffle'],
        'navigable': value['navigable'],
        'encrypted': value['encrypted'],
        'validation': value['validation'],
        'previewUrl': value['previewUrl'],
        'answersLockable': value['answersLockable'],
        'options': value['options'] == null ? undefined : (value['options'].map(FormOptionCreateCommand_1.FormOptionCreateCommandToJSON)),
        'includeInEmail': value['includeInEmail'],
    };
}
